/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddressDTO } from '@well/address-management-domain-model';

@Injectable({
  providedIn: 'root'
})
export class CompanyAddressResourceService extends AbstractResourceService<any, AddressDTO, any, any> {

  constructor(private environmentService: EnvironmentService, protected httpClient: HttpClient) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('companyAddressUrl')}`,

    );
  }

  getAddressesForBusinessProfile(businessProfileUuid: string, query?: any, additionalParams?: any): Observable<JsonApiResource<any[], any>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []
    ).toString();
    return this.httpClient.get<JsonApiResource<any[], any>>(`${this.url}/business-profile/${businessProfileUuid}${queryString}`).pipe(
      map((jsonApiResource) => {
        jsonApiResource.data = jsonApiResource.data.map((item: any) => AbstractResourceService.resourceMapper(undefined, item)
        );
        jsonApiResource.meta = AbstractResourceService.resourceMapper(
          this.mvType,
          jsonApiResource.meta
        );
        return jsonApiResource;
      })
    );
  }

  getPartnerTemplate(businessProfileUuid: string, path = '', query = ''): Observable<JsonApiResource<any, any>> {
    return this.httpClient
      .get<JsonApiResource<any, any>>(`${this.url}/new/template/${businessProfileUuid}${path}?${query}`)
      .pipe(this.getDtoMapper());
  }

  saveCompanyAddress(resource: AddressDTO) {
    return this.httpClient
      .post(`${this.url}/company-address`, resource, { headers: this.headers })
      .pipe(this.getDtoMapper());
  }

}
